import { useAppContext } from '@/context/AppContext';
import {
  CATEGORIZE_GROUPS,
  CATEGORIZE_CLIENTS,
  CATEGORIZE_PROJECTS,
  CATEGORIZE_TOTAL_HOURS,
} from '@/data/categorizeGroups';
import type { CategorizeGroup } from '@/data/categorizeGroups';

interface UseCategorizeGroupsResult {
  groups: readonly CategorizeGroup[];
  clients: readonly string[];
  projects: readonly string[];
  totalHours: string;
  isLoading: boolean;
}

export function useCategorizeGroups(): UseCategorizeGroupsResult {
  const { mockupMode } = useAppContext();
  if (mockupMode) {
    return {
      groups: CATEGORIZE_GROUPS,
      clients: CATEGORIZE_CLIENTS,
      projects: CATEGORIZE_PROJECTS,
      totalHours: CATEGORIZE_TOTAL_HOURS,
      isLoading: false,
    };
  }
  // Categorize groups require fallback-samples + unique-apps — deferred
  return { groups: [], clients: [], projects: [], totalHours: '0h', isLoading: false };
}
